export default __webpack_public_path__ + "static/media/redux.1f74541c.svg";